export const WORKSPACE_TAB_QUERY_KEY = 'tab';
export const DESIGN_KIT_SECTION_QUERY_KEY = 'designKit';

export const MARKETPLACE_TEMPLATE_QUERY_KEYS = {
    category: 'category',
    sort: 'order',
    search: 'search',
    commercial: 'commercialStatus',
} as const;

export const MARKETPLACE_COMPONENT_QUERY_KEYS = {
    category: 'componentCategory',
    sort: 'componentSort',
    search: 'componentSearch',
    commercial: 'componentCommercialStatus',
} as const;

export const ASSET_ID_PARAM = 'assetId';
export const ASSET_TYPE_PARAM = 'assetType';

const TEMPLATE_QUERY_KEYS = Object.values(MARKETPLACE_TEMPLATE_QUERY_KEYS);
const COMPONENT_QUERY_KEYS = Object.values(MARKETPLACE_COMPONENT_QUERY_KEYS);
const DETAIL_QUERY_KEYS = [ASSET_ID_PARAM, ASSET_TYPE_PARAM] as const;

function deleteQueryKeys(params: URLSearchParams, keys: readonly string[]) {
    keys.forEach(key => params.delete(key));
}

export function stripMarketplaceDetailParams(params: URLSearchParams): URLSearchParams {
    deleteQueryKeys(params, DETAIL_QUERY_KEYS);
    return params;
}

export function sanitizeMarketplaceSearchParamsForTab(
    searchParams: URLSearchParams,
    targetTab: string
): URLSearchParams {
    if (targetTab === 'design-kit') {
        const nextParams = new URLSearchParams();
        nextParams.set(WORKSPACE_TAB_QUERY_KEY, targetTab);
        return nextParams;
    }

    const nextParams = new URLSearchParams(searchParams);

    if (targetTab === 'templates') {
        deleteQueryKeys(nextParams, COMPONENT_QUERY_KEYS);
        stripMarketplaceDetailParams(nextParams);
    } else if (targetTab === 'components') {
        deleteQueryKeys(nextParams, TEMPLATE_QUERY_KEYS);
        stripMarketplaceDetailParams(nextParams);
    } else {
        deleteQueryKeys(nextParams, TEMPLATE_QUERY_KEYS);
        deleteQueryKeys(nextParams, COMPONENT_QUERY_KEYS);
        stripMarketplaceDetailParams(nextParams);
    }

    nextParams.delete(DESIGN_KIT_SECTION_QUERY_KEY);

    nextParams.set(WORKSPACE_TAB_QUERY_KEY, targetTab);
    return nextParams;
}

/** 切换 Design Kit 内部页面，顶层 tab 始终保持 design-kit。 */
export function sanitizeMarketplaceSearchParamsForDesignKitSection(
    searchParams: URLSearchParams,
    section: 'home' | 'templates' | 'components'
): URLSearchParams {
    const nextParams = new URLSearchParams(searchParams);
    stripMarketplaceDetailParams(nextParams);

    if (section === 'templates') {
        deleteQueryKeys(nextParams, COMPONENT_QUERY_KEYS);
    } else if (section === 'components') {
        deleteQueryKeys(nextParams, TEMPLATE_QUERY_KEYS);
    } else {
        deleteQueryKeys(nextParams, TEMPLATE_QUERY_KEYS);
        deleteQueryKeys(nextParams, COMPONENT_QUERY_KEYS);
    }

    nextParams.set(WORKSPACE_TAB_QUERY_KEY, 'design-kit');
    if (section === 'home') {
        nextParams.delete(DESIGN_KIT_SECTION_QUERY_KEY);
    } else {
        nextParams.set(DESIGN_KIT_SECTION_QUERY_KEY, section);
    }
    return nextParams;
}
